// Inline editing functionality for resource names
class InlineEdit {
  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    // Use event delegation for dynamically loaded content
    $(document).on('click', '.inline-edit-trigger', this.startEdit.bind(this));
    $(document).on('click', '.save-field', this.saveField.bind(this));
    $(document).on('click', '.cancel-edit', this.cancelEdit.bind(this));
    $(document).on('keydown', '.field-input', this.handleKeydown.bind(this));
    $(document).on('blur', '.field-input', this.handleBlur.bind(this));
  }

  startEdit(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const container = $(e.target).closest('.inline-edit-container');
    
    // All fields now use the generic naming convention
    const displaySpan = container.find('.field-display');
    const editDiv = container.find('.field-edit');
    const input = container.find('.field-input');
    
    // Hide display, show edit
    displaySpan.hide();
    editDiv.show();
    
    // Focus and select the input text
    input.focus().select();
  }

  cancelEdit(e) {
    e.preventDefault();
    
    const container = $(e.target).closest('.inline-edit-container');
    const field = container.data('field') || 'name';
    
    // All fields now use the generic naming convention
    const displaySpan = container.find('.field-display');
    const editDiv = container.find('.field-edit');
    const input = container.find('.field-input');
    
    const originalValue = input.data('original-value');
    
    // Reset to original value
    input.val(originalValue);
    
    // Hide edit, show display
    editDiv.hide();
    displaySpan.show();
    
    // Clear any error states
    this.clearError(container, field);
  }


  saveField(e) {
    e.preventDefault();
    
    const container = $(e.target).closest('.inline-edit-container');
    const resourceId = container.data('camera-id') || container.data('resource-id');
    const resourceType = container.data('resource-type') || 'cameras';
    const field = container.data('field');
    const input = container.find('.field-input');
    const newValue = input.val().trim();
    const originalValue = input.data('original-value') || '';
    
    // Don't save if unchanged
    if (newValue === originalValue) {
      this.cancelEdit(e);
      return;
    }
    
    // Client-side validation for name field
    if (field === 'name' && !newValue) {
      this.showError(container, 'Name cannot be empty', field);
      return;
    }
    
    // Disable save button during request
    const saveBtn = container.find('.save-field');
    saveBtn.prop('disabled', true).html('<i class="fas fa-spinner fa-spin"></i>');
    
    // Send AJAX request
    $.ajax({
      url: `/${resourceType}/${resourceId}/update_field`,
      method: 'PUT',
      data: {
        field: field,
        value: newValue
      },
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      success: (response) => {
        if (response.success) {
          // Update the display based on field type
          if (field === 'name') {
            // For name fields, find the link within the display container and update its text
            const displaySpan = container.find('.field-display');
            const link = displaySpan.find('a');
            if (link.length > 0) {
              link.text(response.value || response.name);
            }
          } else if (field === 'username') {
            const fieldText = container.find('.field-text');
            fieldText.text(newValue || 'No username');
          } else if (field === 'password') {
            // Password display stays as *****, no change needed
          }
          
          // Update the original value for future edits
          input.data('original-value', newValue);
          input.val(newValue);
          
          // Hide edit, show display
          const displaySpan = container.find('.field-display');
          const editDiv = container.find('.field-edit');
          editDiv.hide();
          displaySpan.show();
          
          // Show success message
          if (response.message) {
            this.showToast('success', response.message);
          }
          
          // Clear error state
          this.clearError(container, field);
        } else {
          this.showError(container, response.error || 'Update failed', field);
        }
      },
      error: (xhr) => {
        let errorMessage = 'Update failed';
        
        if (xhr.responseJSON && xhr.responseJSON.error) {
          errorMessage = xhr.responseJSON.error;
        } else if (xhr.status === 403) {
          errorMessage = `You do not have permission to edit this ${field}`;
        } else if (xhr.status === 422) {
          errorMessage = `Invalid ${field} provided`;
        }
        
        this.showErrorModal(errorMessage, container);
      },
      complete: () => {
        // Re-enable save button
        saveBtn.prop('disabled', false).html('<i class="fas fa-check"></i>');
      }
    });
  }

  handleKeydown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      const container = $(e.target).closest('.inline-edit-container');
      
      // All fields now use the generic save button
      container.find('.save-field').click();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      $(e.target).closest('.inline-edit-container').find('.cancel-edit').click();
    }
  }

  handleBlur(e) {
    // Small delay to allow clicking save/cancel buttons
    setTimeout(() => {
      const container = $(e.target).closest('.inline-edit-container');
      
      // All fields now use the generic edit div
      const editDiv = container.find('.field-edit');
      
      // Only auto-cancel if edit mode is still visible and no buttons were clicked
      if (editDiv.is(':visible') && !editDiv.find(':focus').length) {
        container.find('.cancel-edit').click();
      }
    }, 200);
  }

  showError(container, message, field = 'name') {
    // All fields now use the generic error handling
    const errorDiv = container.find('.field-error');
    const input = container.find('.field-input');
    
    errorDiv.text(message).show();
    input.addClass('is-invalid');
  }

  clearError(container, field = 'name') {
    // All fields now use the generic error handling
    const errorDiv = container.find('.field-error');
    const input = container.find('.field-input');
    
    errorDiv.hide();
    input.removeClass('is-invalid');
  }


  showErrorModal(message, container) {
    // Pause ActionCable datatable refreshing
    this.pauseDataTableRefresh();
    
    // Use Turbo to fetch and render the modal
    const params = new URLSearchParams({
      message: message,
      title: 'Unable to Update Name'
    });
    
    fetch(`/shared/error_modal?${params}`, {
      method: 'GET',
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.text())
    .then(html => {
      // Remove any existing modal
      $('#inline-edit-error-modal').remove();
      
      // Add modal to page
      document.body.insertAdjacentHTML('beforeend', html);
      
      // Show modal
      $('#inline-edit-error-modal').modal('show');
      
      // Clean up when modal is hidden and resume datatable refresh
      $('#inline-edit-error-modal').on('hidden.bs.modal', () => {
        this.resumeDataTableRefresh();
        // Manually trigger cancel without requiring an event object
        const displaySpan = container.find('.field-display');
        const editDiv = container.find('.field-edit');
        const input = container.find('.field-input');
        const originalValue = input.data('original-value');
        input.val(originalValue);
        editDiv.hide();
        displaySpan.show();
        this.clearError(container, container.data('field') || 'name');
        $('#inline-edit-error-modal').remove();
      });
    })
    .catch(error => {
      console.error('Error loading modal:', error);
      // Fallback to alert
      alert(message);
      this.resumeDataTableRefresh();
      // Manually trigger cancel without requiring an event object
      const displaySpan = container.find('.field-display');
      const editDiv = container.find('.field-edit');
      const input = container.find('.field-input');
      const originalValue = input.data('original-value');
      input.val(originalValue);
      editDiv.hide();
      displaySpan.show();
      this.clearError(container, container.data('field') || 'name');
    });
  }

  pauseDataTableRefresh() {
    // Pause ActionCable table refreshing if available
    if (window.App && window.App.table_channel) {
      window.App.table_channel.paused = true;
    }
  }

  resumeDataTableRefresh() {
    // Resume ActionCable table refreshing if available
    if (window.App && window.App.table_channel) {
      window.App.table_channel.paused = false;
    }
  }

  showToast(type, message) {
    // Use existing toast notification system if available
    if (typeof window.showToast === 'function') {
      window.showToast(type, message);
    } else if (typeof window.flash_msg === 'function') {
      window.flash_msg(type, message);
    } else {
      // Fallback to simple alert
      console.log(`${type.toUpperCase()}: ${message}`);
    }
  }
}

// Initialize when DOM is ready
$(document).ready(() => {
  new InlineEdit();
});

// Export for manual initialization if needed
window.InlineEdit = InlineEdit;